export default __webpack_public_path__ + "static/media/noPetitionsFallbackIcon.75c00594.svg";